import gql from 'graphql-tag'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'

const query = gql`
  query me {
    me {
      current_plan {
        id
        regime
        pnns_choice
        structure
        start_at
        created_at
        express
        preferences {
          moment
        }
      }
    }
  }
`

const transformer = ({ me }: any): any => me

type variables = any

export default queryServiceCreator<variables>(query, transformer)
